import { render } from "./KisilerDetayView.vue?vue&type=template&id=00dd076a"
import script from "./KisilerDetayView.vue?vue&type=script&lang=js"
export * from "./KisilerDetayView.vue?vue&type=script&lang=js"

import "./KisilerDetayView.vue?vue&type=style&index=0&id=00dd076a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__